import { createQueryDataTable, type PropsOfQueryDataTable } from '~/shared/data-tables/query/QueryDataTable';
import { LegacyOasisTrackingTable } from './LegacyOasisTrackingTable';

const LegacyOasisTrackingAveragesDataTable = createQueryDataTable('legacy-oasis-tracking-averages');
type TableProps = PropsOfQueryDataTable<typeof LegacyOasisTrackingAveragesDataTable>;

export interface VwOasistrackingaverage {
	totalRows?: number;
	avgDaysFirstSentToOffice?: number;
	firstSentSampleSize?: number;
	avgDaysLastSentToOffice?: number;
	lastSentSampleSize?: number;
	rolling30AvgDaysFirstSentToOffice?: number;
	rolling30AvgDaysLastSentToOffice?: number;
}

const columnDefinitions = LegacyOasisTrackingAveragesDataTable.columns([
	{
		header: 'User',
		key: 'name',
		sortable: true
	},
	{
		header: 'Avg Days First Sent',
		key: 'avgDaysFirstSentToOffice',
		width: 'w-[100px]',
		sortable: true,
		renderCell: row => row.avgDaysFirstSentToOffice?.toFixed(2) ?? '-'
	},
	{
		header: 'First Sent Count',
		key: 'firstSentSampleSize',
		width: 'w-[100px]',
		sortable: true,
		renderCell: row => row.firstSentSampleSize ?? '-'
	},
	{
		header: 'Avg Days Last Sent',
		key: 'avgDaysLastSentToOffice',
		width: 'w-[100px]',
		sortable: true,
		renderCell: row => row.avgDaysLastSentToOffice?.toFixed(2) ?? '-'
	},
	{
		header: 'Last Sent Count',
		key: 'lastSentSampleSize',
		width: 'w-[100px]',
		sortable: true,
		renderCell: row => row.lastSentSampleSize ?? '-'
	},
	{
		header: 'First Sent 30 Day Avg',
		key: 'rolling30AvgDaysFirstSentToOffice',
		width: 'w-[100px]',
		sortable: true,
		renderCell: row => row.rolling30AvgDaysFirstSentToOffice?.toFixed(2) ?? '-'
	},
	{
		header: 'Last Sent 30 Day Avg',
		key: 'rolling30AvgDaysLastSentToOffice',
		width: 'w-[100px]',
		sortable: true,
		renderCell: row => row.rolling30AvgDaysLastSentToOffice?.toFixed(2) ?? '-'
	}
]);

export function LegacyOasisTrackingAveragesTable(props: TableProps) {
	return (
		<LegacyOasisTrackingAveragesDataTable.Table
			columns={columnDefinitions}
			emptyMessage="No OASIS found"
			{...props}
			exportable
			getRowId={x => x.caregiverCode}
			renderRowDetail={row => (
				<LegacyOasisTrackingTable
					type="inner-with-filters"
					staticFilters={[{ name: 'caregiverCode', operator: '==', value: row.caregiverCode }]}
				/>
			)}
		/>
	);
}
